export function getJsonBlobFromFormData(formData: FormData): Blob | null {
  let jsonBlob = formData.get('requestDTO') as Blob | null;
  if (jsonBlob) return jsonBlob;
  let firstJsonCandidate: Blob | null = null;

  formData.forEach((value, key) => {
    if (value instanceof Blob) {
      const mime = value.type?.toLowerCase() || '';
      if (mime.includes('json')) {
        if (!firstJsonCandidate) {
          firstJsonCandidate = value;
        }
      }
    }
  });

  if (firstJsonCandidate) return firstJsonCandidate;

  let firstBlob: Blob | null = null;
  formData.forEach((value) => {
    if (!firstBlob && value instanceof Blob) {
      firstBlob = value;
    }
  });

  return firstBlob;
}
